// extracted by mini-css-extract-plugin
export default {"thumbsUp":"MessageFeedbackDialog-module__thumbsUp--L1svG","thumbsDown":"MessageFeedbackDialog-module__thumbsDown--xdoe9"};